export default __webpack_public_path__ + "img/share.022aaacc.svg";